import EmblaCarousel from 'embla-carousel';
import EmblaAutoplay from 'embla-carousel-autoplay';
import AutoScroll from 'embla-carousel-auto-scroll';
// import ClassNames from 'embla-carousel-class-names';
import EmblaFade from 'embla-carousel-fade';
// import EmblaAutoHeight from 'embla-carousel-auto-height';
import { addEmblaDotClickHandlers, addEmblaPrevNextClickHandlers } from '../plugins/EmblaCarouselFeatures.js';

import { checkAutoplaySupport, getAbsolutePosition } from '../utiles/index.js';

const initEmblaCarousel = async () => {
	const emblaImgVideo = document.querySelectorAll('.embla-imgvideo');
	if (emblaImgVideo.length) {
		let videoAutoplaySupported = true;
		// 检测移动端是否支持视频自动播放
		const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
		if (isMobile) {
			try {
				const autoplaySupport = await checkAutoplaySupport({ muted: true });
				videoAutoplaySupported = autoplaySupport.muted;
				// console.log('Mobile autoplay support:', videoAutoplaySupported);
			} catch (error) {
				// console.log('Autoplay detection failed:', error);
				videoAutoplaySupported = false;
			}
		}

		emblaImgVideo.forEach((imgvideo) => {
			// 不使用EmblaAutoplay插件，改用自定义计时器控制
			const emblaNode = imgvideo.querySelector('.embla__viewport');
			const emblaApi = new EmblaCarousel(emblaNode, { loop: true }, [EmblaFade()]);

			const btnPrev = imgvideo.querySelector('.embla-imgvideo-prev');
			const btnNext = imgvideo.querySelector('.embla-imgvideo-next');

			addEmblaPrevNextClickHandlers(emblaApi, btnPrev, btnNext);

			const mouseCircle = imgvideo.querySelector('.embla-mouse-circle');
			if (mouseCircle) {
				imgvideo.addEventListener('mousemove', (e) => {
					// console.log(e.pageX, e.pageY);
					mouseCircle.style.left = e.pageX - imgvideo.offsetLeft + 'px';
					mouseCircle.style.top = e.pageY - imgvideo.offsetTop + 'px';
				});
			}

			const slides = emblaApi.slideNodes();
			let currentVideo = null;
			let autoplayTimer = null;
			let isVideoPlaying = false;
			let userClickedPlay = false;

			// 清理计时器的函数
			const clearAutoplayTimer = () => {
				if (autoplayTimer) {
					clearTimeout(autoplayTimer);
					autoplayTimer = null;
					// console.log('autoplay timer cleared');
				}
			};

			// 启动自动播放计时器的函数
			const startAutoplayTimer = () => {
				clearAutoplayTimer();
				if (!isVideoPlaying || (isMobile && !videoAutoplaySupported && !userClickedPlay)) {
					autoplayTimer = setTimeout(() => {
						// console.log('autoplay timer triggered');
						// 如果用户点击了播放按钮，不要在计时器触发时切换
						if (!(userClickedPlay && currentVideo && !currentVideo.ended)) {
							emblaApi.scrollNext();
						}
					}, 4000); // 4秒后自动切换
					// console.log('autoplay timer started');
				}
			};

			// 为所有视频绑定事件
			slides.forEach((slide) => {
				const video = slide.querySelector('video');
				if (video) {
					const isMobile = window.innerWidth < 641;
					const src = isMobile ? video.dataset.srcM : video.dataset.srcPc;
					const poster = isMobile ? video.dataset.posterM : video.dataset.posterPc;

					if (src) {
						video.src = src;
					}
					if (poster) {
						video.poster = poster;
					}

					// 如果是移动端且不支持自动播放，显示控制按钮
					if (isMobile && !videoAutoplaySupported) {
						video.controls = true;

						// 用户点击播放按钮时的处理
						video.addEventListener('play', () => {
							// console.log('user clicked play button');
							userClickedPlay = true;
							clearAutoplayTimer();
						});
					}

					// 视频播放结束事件
					video.addEventListener('ended', () => {
						// console.log('video ended, switching to next slide');
						isVideoPlaying = false;
						userClickedPlay = false;
						currentVideo = null;
						emblaApi.scrollNext();
					});
				}
			});

			const updateEmblaApi = () => {
				// console.log('slide changed');
				const selectedIndex = emblaApi.selectedScrollSnap();
				const currentSlide = slides[selectedIndex];
				const video = currentSlide.querySelector('video');

				const bgcolor = currentSlide.dataset.bgcolor;
				if (bgcolor) {
					// document.body.classList.remove('header-bg-black', 'header-bg-white');
					if (bgcolor === 'black') {
						document.body.classList.add('header-bg-white');
					} else {
						document.body.classList.remove('header-bg-white');
					}
				}

				// 清理之前的计时器
				clearAutoplayTimer();

				// 停止所有视频播放
				slides.forEach((slide) => {
					const v = slide.querySelector('video');
					if (v) {
						v.pause();
						v.currentTime = 0;
					}
				});

				if (video) {
					// console.log('current slide has video');
					isVideoPlaying = true;
					currentVideo = video;
					video.currentTime = 0;

					// 根据是否支持自动播放决定处理方式
					if (isMobile && !videoAutoplaySupported) {
						// console.log('mobile device without autoplay support');
						// 移动端不支持自动播放时，启动4秒计时器，除非用户点击了播放
						startAutoplayTimer();
					} else {
						// 支持自动播放或桌面端，直接播放视频
						video.play().catch((e) => console.log('video play error:', e));
					}
				} else {
					// console.log('current slide is image, starting autoplay timer');
					isVideoPlaying = false;
					currentVideo = null;
					startAutoplayTimer();
				}
			};

			emblaApi.on('init', updateEmblaApi).on('select', updateEmblaApi);

			// 页面隐藏时清理计时器，避免后台运行问题
			document.addEventListener('visibilitychange', () => {
				if (document.hidden) {
					clearAutoplayTimer();
					if (currentVideo) {
						currentVideo.pause();
					}
				} else if (!isVideoPlaying || (isMobile && !videoAutoplaySupported && !userClickedPlay)) {
					startAutoplayTimer();
				}
			});
		});
	}

	const clientsNode = document.querySelectorAll('.embla-clients');
	if (clientsNode.length) {
		clientsNode.forEach((client, index) => {
			const autoScrollPlugin = AutoScroll({ speed: Math.random() * 2 + 1, stopOnMouseEnter: true, startDelay: 100 });
			const emblaApi = new EmblaCarousel(client, { loop: true }, [autoScrollPlugin]);

			// 添加鼠标离开事件来恢复滚动
			client.addEventListener('mouseleave', () => {
				// 重新启动自动滚动
				autoScrollPlugin.play();
			});
		});
	}

	const aboutSlides = document.querySelectorAll('.embla-about-slide');
	if (aboutSlides.length) {
		aboutSlides.forEach((slide) => {
			const autoplayPlugin = EmblaAutoplay({ playOnInit: true, delay: 4000 });
			const emblaApi = new EmblaCarousel(slide, { loop: true }, [autoplayPlugin]);
			const btnPrev = slide.querySelector('.about-slide-prev');
			const btnNext = slide.querySelector('.about-slide-next');
			addEmblaPrevNextClickHandlers(emblaApi, btnPrev, btnNext);

			// 在点击后重新启动自动播放
			const resetAutoplay = () => {
				autoplayPlugin.reset();
				autoplayPlugin.play();
			};

			if (btnPrev) {
				btnPrev.addEventListener('click', resetAutoplay);
			}
			if (btnNext) {
				btnNext.addEventListener('click', resetAutoplay);
			}

			const mouseCircle = slide.querySelector('.embla-mouse-circle');
			if (mouseCircle) {
				const position = getAbsolutePosition(slide);
				slide.addEventListener('mousemove', (e) => {
					console.log(e.pageX, e.pageY, slide.offsetLeft, slide.offsetTop);
					mouseCircle.style.left = e.pageX - position.left + 'px';
					mouseCircle.style.top = e.pageY - position.top + 'px';
				});
			}
		});
	}

	const moreWorks = document.querySelector('.embla-more-work');
	if (moreWorks) {
		const emblaApi = new EmblaCarousel(moreWorks, { loop: true, align: 'start', slidesToScroll: window.innerWidth > 640 ? 2 : 1 });
		const btnNext = document.querySelector('.btn-next-emwork');
		btnNext.addEventListener('click', () => {
			emblaApi.scrollNext();
		});
	}
};

export { initEmblaCarousel };
